export const dict = {
  es: {
    nav: {
      solutions: "Soluciones",
      services: "Servicios",
      process: "Proceso",
      contact: "Contacto",
      quote: "Solicitar cotización",
    },
    projects: {
      similar: "Solicitar algo similar",
      gallery: "Ver galería",
      demo_badge: "Demostración",
      demo_note: "Proyecto conceptual de demostración",
      visit: "Ver demostración",
      empty_title: "Galería en preparación",
      empty_text: "Estamos preparando ejemplos de nuestras soluciones. Vuelve a visitarnos pronto.",
      all: "Todo",
    },
    services: {
      empty_title: "Servicios por anunciar",
      empty_text: "Estamos definiendo nuestros paquetes y promociones. Escríbenos y te contamos más.",
      promo: "Promoción",
      cta: "Solicitar este servicio",
    },
    process: {
      steps: [
        { title: "Presentación de la idea", desc: "Nos cuentas qué necesitas: tu negocio, tus objetivos y la solución que imaginas." },
        { title: "Definición de requisitos", desc: "Convertimos tu idea en un plan claro: funciones, alcance, tiempos y prioridades." },
        { title: "Diseño y desarrollo", desc: "Diseñamos y construimos tu solución con acabados premium y avances visibles." },
        { title: "Preparación del lanzamiento", desc: "Probamos, ajustamos y dejamos todo listo para que tu proyecto salga al mundo." },
      ],
    },
    form: {
      name: "Nombre",
      name_ph: "Tu nombre completo",
      business: "Nombre del negocio",
      business_ph: "Opcional",
      contact: "Correo electrónico o teléfono",
      contact_ph: "¿Dónde te contactamos?",
      type: "Tipo de proyecto",
      type_ph: "Selecciona una opción",
      description: "Descripción",
      description_ph: "Cuéntanos qué quieres construir...",
      budget: "Presupuesto aproximado",
      budget_ph: "Opcional",
      send: "Enviar solicitud",
      sending: "Enviando...",
      success_title: "Solicitud recibida",
      success_text: "Gracias por escribirnos. Revisaremos tu solicitud y te contactaremos pronto.",
      error: "No se pudo enviar. Inténtalo de nuevo.",
      required: "Completa los campos obligatorios.",
      other: "Otro",
      attach_label: "Imágenes de referencia",
      attach_hint: "Hasta 6 imágenes · PNG, JPG o WEBP · máx. 8 MB cada una",
      attach_add: "Adjuntar imágenes",
      attach_uploading: "Subiendo...",
      attach_error: "Una imagen no se pudo subir",
      attach_limit: "Máximo 6 imágenes",
    },
    contact: {
      whatsapp: "Escríbenos por WhatsApp",
      email: "Enviar correo",
    },
    footer: {
      rights: "Todos los derechos reservados.",
    },
  },
  en: {
    nav: {
      solutions: "Solutions",
      services: "Services",
      process: "Process",
      contact: "Contact",
      quote: "Request a Quote",
    },
    projects: {
      similar: "Request something similar",
      gallery: "View gallery",
      demo_badge: "Demo",
      demo_note: "Concept demonstration project",
      visit: "View demo",
      empty_title: "Gallery coming soon",
      empty_text: "We are preparing examples of our solutions. Check back soon.",
      all: "All",
    },
    services: {
      empty_title: "Services to be announced",
      empty_text: "We are defining our packages and promotions. Reach out and we'll tell you more.",
      promo: "Promotion",
      cta: "Request this service",
    },
    process: {
      steps: [
        { title: "Share your idea", desc: "Tell us what you need: your business, your goals and the solution you imagine." },
        { title: "Requirements definition", desc: "We turn your idea into a clear plan: features, scope, timelines and priorities." },
        { title: "Design & development", desc: "We design and build your solution with premium finishes and visible progress." },
        { title: "Launch preparation", desc: "We test, refine and get everything ready for your project to go live." },
      ],
    },
    form: {
      name: "Name",
      name_ph: "Your full name",
      business: "Business name",
      business_ph: "Optional",
      contact: "Email or phone",
      contact_ph: "Where can we reach you?",
      type: "Project type",
      type_ph: "Select an option",
      description: "Description",
      description_ph: "Tell us what you want to build...",
      budget: "Approximate budget",
      budget_ph: "Optional",
      send: "Send request",
      sending: "Sending...",
      success_title: "Request received",
      success_text: "Thank you for reaching out. We will review your request and contact you soon.",
      error: "Could not send. Please try again.",
      required: "Please complete the required fields.",
      other: "Other",
      attach_label: "Reference images",
      attach_hint: "Up to 6 images · PNG, JPG or WEBP · max 8 MB each",
      attach_add: "Attach images",
      attach_uploading: "Uploading...",
      attach_error: "An image could not be uploaded",
      attach_limit: "Maximum 6 images",
    },
    contact: {
      whatsapp: "Message us on WhatsApp",
      email: "Send email",
    },
    footer: {
      rights: "All rights reserved.",
    },
  },
};
